import { useProfile, type ProfileData } from '@/hooks/use-profile'
import {
  RichTextMarkdownArtifactCanvas,
  useMarkdownArtifactDraft,
} from '@/components/artifact/rich-text-markdown-artifact-canvas'
import { markdownFieldLengthError } from '@/lib/rich-text-visible-char-count'

interface ProfileAboutCanvasProps {
  profile: ProfileData
  onClose: () => void
}

export function ProfileAboutCanvas({ profile, onClose }: ProfileAboutCanvasProps) {
  const { updateProfile, isUpdating, updateError } = useProfile()
  const profileId = profile.id ?? profile.email ?? 'profile'
  const draft = useMarkdownArtifactDraft(profile.bio ?? '', profileId)

  const handleSave = () => {
    const bioLengthErr = markdownFieldLengthError(draft.value, 'Bio')
    if (bioLengthErr) {
      draft.setValidationError(bioLengthErr)
      return
    }

    draft.setValidationError(null)

    updateProfile(
      { bio: draft.value.trim() },
      {
        onSuccess: () => {
          onClose()
        },
      },
    )
  }

  return (
    <RichTextMarkdownArtifactCanvas
      id="artifact-profile-about"
      value={draft.value}
      onChange={draft.onChange}
      charCount={draft.charCount}
      onCharCountChange={draft.onCharCountChange}
      validationError={draft.validationError}
      serverError={updateError?.message}
      onClose={onClose}
      onSave={handleSave}
      isDirty={draft.isDirty}
      isSaving={isUpdating}
    />
  )
}
